import { useEffect, useState } from 'react'
import { Empty } from 'antd'
import PaymentService from '../../../../services/paymentService'
import { useAppParamsContext } from '../../../../context/AppParamsContext'
import { checkShowPaymentMethodWithTheme } from '../../../../helper/paymentMethod'
import SafeImage from '../../../../components/BasicComponent/SafeImage'
import './index.scss'

export default function AutoTrafficFinePayment({ paymentMethod, setPaymentMethod }) {
  const { paymentMethodType } = useAppParamsContext()
  const [listPaymentMethod, setListPaymentMethod] = useState({})

  useEffect(() => {
    let isMounted = true

    async function fetchPaymentMethods() {
      try {
        const response = await PaymentService.getPaymentQRMethod({})

        if (!isMounted || !response || typeof response !== 'object') {
          return
        }

        let filteredData = Object.values(response)
        if (paymentMethodType) {
          filteredData = filteredData.filter((item) => item.paymentMethodType === paymentMethodType)
        } else {
          // Lọc theo theme đối tác hiện tại.
          filteredData = checkShowPaymentMethodWithTheme(filteredData)
        }

        const dataConverted = Object.fromEntries(filteredData.map((item) => [item.paymentMethodId, item]))
        const firstPaymentMethod = Object.values(dataConverted || {})?.[0]

        if (firstPaymentMethod) {
          setPaymentMethod(firstPaymentMethod)
        }
        setListPaymentMethod(dataConverted)
      } catch {
        // Lỗi mạng / API: hiển thị Empty state.
        if (isMounted) {
          setListPaymentMethod({})
        }
      }
    }

    fetchPaymentMethods()

    return () => {
      isMounted = false
    }
  }, [paymentMethodType, setPaymentMethod])

  const paymentMethodKeys = Object.keys(listPaymentMethod)
  const onlyOneMethod = paymentMethodKeys.length === 1

  return (
    <div className="autoTrafficFinePayment">
      <div className="autoTrafficFinePayment_paymentMethodSection">
        <div className="section-title">Phương Thức Thanh Toán</div>
        <div style={{ color: 'var(--text-secondary)', fontSize: '14px', lineHeight: '1.5', fontWeight: 400 }}>Vui lòng chọn 1 hình thức</div>
        {paymentMethodKeys.length > 0 ? (
          <div className="payment-method-grid">
            {paymentMethodKeys.map((key) => {
              const method = listPaymentMethod[key]
              const isActive = +paymentMethod?.paymentMethodId === +key

              return (
                <div
                  key={key}
                  onClick={() => setPaymentMethod(method)}
                  className={`payment-method-item ${isActive ? 'active' : ''} ${onlyOneMethod ? 'w-100' : ''}`.trim()}>
                  <SafeImage height={30} src={method?.paymentMethodImageUrl} style={{ marginBottom: '8px' }} />
                  <div className="payment-method-name">{method.paymentMethodName || key}</div>
                </div>
              )
            })}
          </div>
        ) : (
          <Empty description="Không có phương thức thanh toán" />
        )}
      </div>
    </div>
  )
}
